export default __webpack_public_path__ + "static/media/hero-image.6181d7bd.png";